export const ADD_PRODUCT = 'ADD_PRODUCT';
export const RESET_STATE = 'RESET_STATE';